import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { runtimeEnvironment } from './environments/environment.docker';
import { Amplify } from 'aws-amplify';

if (runtimeEnvironment.production) {
  enableProdMode();
}

const authConfig: any = {
  Cognito: {
    userPoolId: runtimeEnvironment.userPoolId,
    userPoolClientId: runtimeEnvironment.userPoolWebClientId,
    awsCognitoIdentityPoolId: runtimeEnvironment.awsCognitoIdentityPoolId,
  }
};

Amplify.configure({
  Auth: authConfig
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
